module.exports = __webpack_public_path__ + "img/thumbnail-230593602.3da5819b.jpeg";